import React, { useState } from "react";
// react component for creating dynamic tables
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import ReactBSAlert from "react-bootstrap-sweetalert";
import { useHistory } from "react-router-dom";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";

import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
// @material-ui/lab components
// @material-ui/icons components
// core components
import Snackbar from "components/Snackbar/Snackbar.js";
import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import btnComponentStyles from "assets/theme/components/button.js";
import LoadingAnimation from "components/Animations/loading";
import Slide from "@material-ui/core/Slide";
import { useAsyncEffect } from "use-async-effect";
import { redirectToLogout,numericSortFunc,zeroFill } from "common/SharedFn";
import { getAllProSubscriptionPackages,updateProSubscriptionPackage } from "../../network/ApiAxios";
import {  Check,Block, Edit, List } from "@material-ui/icons";
import "react-datepicker/dist/react-datepicker.css";

const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(btnComponentStyles);
const createHistory = require("history").createBrowserHistory;

const pagination = paginationFactory({
  page: 1,
  alwaysShowAllBtns: true,
  showTotal: true,
  withFirstAndLast: false,
  sizePerPage:50,
  sizePerPageRenderer: ({ onSizePerPageChange }) => (
    <div className="dataTables_length" id="datatable-basic_length">
      <label>
        Show{" "}
        {
          <select
            name="datatable-basic_length"
            aria-controls="datatable-basic"
            className="form-control form-control-sm"
            onChange={(e) => onSizePerPageChange(e.target.value)}
          >
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="1000">1000</option>
          </select>
        }{" "}
        entries.
      </label>
    </div>
  ),
});

const { SearchBar } = Search;

const { ExportCSVButton } = CSVExport;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const ProSubscriptionPackagesTable = (props) => {
  const classes = { ...useStyles(), ...useStylesButtons() };
  const [alert, setAlert] = React.useState(false);
  const componentRef = React.useRef(null);
  const [data, setData] = useState([]);
  // const [countries, setCountries] = useState([]);
  const [isLoading, setIsLoading] = useState("");
  const [notifMessage, setNotifMessage] = useState("");
  const [showError, setShowError] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [addModal, setAddModal] = useState(false);
  const [nameEn, setNameEn] = useState("");
  const [nameAr, setNameAr] = useState("");
  const [priceMonthly, setPriceMonthly] = useState();
  const [priceAnnually, setPriceAnnually] = useState();
  const [logoUrl, setLogoUrl] = useState("");
  const [headerColor, setHeaderColor] = useState("");
  const [discountPercentage, setDiscountPercentage] = useState();
  const [minimumOrder, setMinimumOrder] = useState(0);
  const [maximumOrder, setMaximumOrder] = useState(99999);
  const [isEnabled, setIsEnabled] = useState(1);
  const [id, setId] = useState();
  const [executeUpdate, setExecuteUpdate] = useState(false);
  const [forceRefresh, setForceRefresh] = useState(false);
  const [file, setFile] = React.useState(null);
  let history = useHistory();
  
  let fileInput = React.createRef();

  const handleImageChange = (e) => {
    e.preventDefault();
    let reader = new FileReader();
    let newFile = e.target.files[0];
    reader.onloadend = () => {
      setFile(newFile);
    };
    if (newFile) {
      reader.readAsDataURL(newFile);
    }
  };

  const accessFeaturesPage = (id) => {
    let history = createHistory();
    history.push("/admin/pro-subscription-pkgs/features/"+id);
    let pathUrl = window.location.href;
    window.location.href = pathUrl;
  };

  const warningAlert = (title,message,action) => {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={title}
        onConfirm={action}
        onCancel={() => setAlert(null)}
        showCancel="true"
        cancelBtnBsStyle="warning"
        cancelBtnText="No"
        confirmBtnBsStyle="success"
        confirmBtnText="Yes"
        btnSize=""
        confirmBtnStyle={{
          marginRight: undefined,
          borderColor: undefined,
          boxShadow: undefined,
        }}
        cancelBtnStyle={{
          marginRight: undefined,
          borderColor: undefined,
          boxShadow: undefined,
        }}
      >
        {message}
      </ReactBSAlert>
    );
  };

  const showSuccessNotification = (message) => {
    setNotifMessage(message);
    setSuccess(true);
    setTimeout(function () {
      setSuccess(false);
    }, 3000);
  };

  const showErrorNotification = (message) => {
    setNotifMessage(message);
    setShowError(true);
    setTimeout(function () {
      setShowError(false);
    }, 3000);
  };
  const setCurrentRecord = (info) => {
    const { id,nameEn,nameAr,priceMonthly,priceAnnually,headerColor,discountPercentage,minimumOrder,maximumOrder,isEnabled,logoUrl} = info;
    setNameEn(nameEn);
    setNameAr(nameAr);
    setLogoUrl(logoUrl);
    setPriceMonthly(priceMonthly);
    setPriceAnnually(priceAnnually);
    setIsEnabled(isEnabled);
    setHeaderColor(headerColor);
    setDiscountPercentage(discountPercentage);
    setMinimumOrder(minimumOrder);
    setMaximumOrder(maximumOrder);
    setId(id);
  };

  const clearCurrentRecord = () => {
    setNameEn("");
    setNameAr("");
    setPriceMonthly();
    setPriceAnnually();
    setHeaderColor("");
    setDiscountPercentage();
    setMinimumOrder(0);
    setMaximumOrder(99999);
    setLogoUrl("");
    setIsEnabled(1);
    setFile(null);
    setId();
    document.getElementById("imageFile").value = "";
  };

  const fetchProSubscriptionPackages = async () => {
    setForceRefresh(false);
    setIsLoading(true);
    try{
    const response = await getAllProSubscriptionPackages();
    const { data } = response;
  
    if (data.result.isSuccess) {
      setData(data.data.map((prop) => makeTableRow(prop)));
      //setError("");
    } else {
      showErrorNotification(data.result.description);
      if(data.result.code == -2){
        redirectToLogout();
      }
    }
    }
    catch(ex){
      showErrorNotification("Failed to fetch pro subscription packages");
    }
    setIsLoading(false);
  };



  // const addSubscriptionPackageAction = async () => {
  //   setIsLoading(true);
  //   try{
  //   const response = await addSubscriptionPackage(frequency,upToBags,isEnabled,price,logoUrl,file);
  //   const { data } = response;
  //   if (data.result.isSuccess) {
  //     showSuccessNotification("Subscription Package Added Successfully");
  //     setAddModal(false);
  //     setForceRefresh(true);
  //   } else {
  //     showErrorNotification(data.result.description);
  //     setIsLoading(false);
  //   }
  //   }
  //   catch(ex){
  //     showErrorNotification("Failed to add subscriptionpackage");
  //     setIsLoading(false);
  //   }
  // };


  const updateSubscriptionPackageAction = async () => {
    setExecuteUpdate(false);
    setIsLoading(true);
    try{
    const response = await updateProSubscriptionPackage(id,nameEn,nameAr,priceMonthly,priceAnnually,headerColor,discountPercentage,minimumOrder,maximumOrder,isEnabled,logoUrl,file);
    const { data } = response;
    if (data.result.isSuccess) {
      showSuccessNotification("Pro Subscription Package Updated Successfully");
      setAddModal(false);
      setForceRefresh(true);      
    } else {
      showErrorNotification(data.result.description);
      setIsLoading(false);
    }
    }
    catch(ex){
      showErrorNotification("Failed to update pro subscription package");
      setIsLoading(false);
    }
  };


  useAsyncEffect(async () => {
    if(executeUpdate){
        updateSubscriptionPackageAction();
    }
    else{
      fetchProSubscriptionPackages();
    }
  }, [executeUpdate,forceRefresh]);

  const makeTableRow = (info) => {
    if(info.isEnabled === 0){
      info.isEnabledText = "No";
    }
    else{
      info.isEnabledText = "Yes";
    }
    // for (var i=0; i < countries.length; i++) {
    //   if(countries[i].id === info.countryId){
    //     info.countryText = countries[i].nameEn;
    //     break;
    //   }
    // }
    return {
      ...info,
      idForm: (
        "PR"+zeroFill(info.id,5)
      ),
      image: (
        <img src={info.logoUrl} width="50px" />
      ),
      actions: (
        <div className="actions-right">
        <Tooltip title="View Features">
            <Button size="small" color="primary" variant="contained" onClick={() => {
                accessFeaturesPage(info.id);
            }}>
              <Box component={List} />
            </Button>
          </Tooltip>
          <Tooltip title="Edit">
            <Button size="small" 
                  classes={{
                    root: classes.buttonContainedWarning,
                  }} 
                  variant="contained" 
                  style={{ marginLeft: "5px" }}
                  onClick={() => {
                    clearCurrentRecord();
                setCurrentRecord(info);
                setAddModal(true);
            }}>
              <Box component={Edit} />
            </Button>
          </Tooltip>
          
          <div style={{ display: "inline-block" }}>
            {info.isEnabled == 1 ? (
              <Tooltip title="Disable">
                <Button
                  size="small"
                  classes={{
                    root: classes.buttonContainedInfo,
                  }}
                  variant="contained"
                  style={{ marginLeft: "5px" }}
                  onClick={() => {warningAlert("Disable Pro Subscription Package","Are you sure you would like to disable the pro subscription package with id "+info.id+"?",async () =>  {
                    setCurrentRecord(info);
                    setIsEnabled(Math.abs(info.isEnabled-1));
                    setAlert(null);
                    setExecuteUpdate(true);
                    
                  })}}
                >
                  <Box component={Block} />
                </Button>
              </Tooltip>
            ) : (
              <Tooltip title="Enable">
                <Button
                  size="small"
                  classes={{
                    root: classes.buttonContainedSuccess,
                  }}
                  variant="contained"
                  style={{ marginLeft: "5px" }}
                  onClick={() => {warningAlert("Enable Pro Subscription Package","Are you sure you would like to enable the pro subscription package with id "+info.id+"?",async () => {
                    setCurrentRecord(info);
                    setIsEnabled(Math.abs(info.isEnabled-1));
                    setAlert(null);
                    setExecuteUpdate(true);
                  })}}
                >
                  <Box component={Check} />
                </Button>
              </Tooltip>
            )}
          </div>
        </div>
      ),
    };
  };

  return (
    <>
      {alert}
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-4.5rem"
        classes={{ root: classes.containerRoot }}
      >

        <Grid container>
          <Grid item xs={12}>
            <Card elevation={0}>
              <CardHeader
                subheader={
                  <>
                    <Box
                      component={Typography}
                      variant="h2"
                      marginBottom="0!important"
                    >
                      <Box component="span">Pro Subscription Packages</Box>
                    </Box>
                  </>
                }
                classes={{ root: classes.cardHeaderRoot }}
              ></CardHeader>
              <div style={{width: "100%"}}>
              <ToolkitProvider
                data={data}
                keyField="id"
                columns={[
                  {
                    dataField: "idForm",
                    text: "ID",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "image",
                    text: "Image",
                    sort: false,
                    csvExport: false,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "nameEn",
                    text: "Name En",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "nameAr",
                    text: "Name Ar",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "priceMonthly",
                    text: "Price Monthly",
                    sort: true,
                    style: {'whiteSpace': 'normal'},
                    sortFunc: numericSortFunc
                  },
                  {
                    dataField: "priceAnnually",
                    text: "Price Annually",
                    sort: true,
                    style: {'whiteSpace': 'normal'},
                    sortFunc: numericSortFunc
                  },
                  {
                    dataField: "headerColor",
                    text: "Header Color",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "discountPercentage",
                    text: "Discount Percentage",
                    sort: true,
                    style: {'whiteSpace': 'normal'},
                    sortFunc: numericSortFunc
                  },
                  {
                    dataField: "minimumOrder",
                    text: "Minimum Order Amount",
                    sort: true,
                    sortFunc: numericSortFunc,
                  },
                  {
                    dataField: "maximumOrder",
                    text: "Maximum Order Amount",
                    sort: true,
                    sortFunc: numericSortFunc,
                  },
                  // {
                  //   dataField: "countryText",
                  //   text: "Country",
                  //   sort: true,
                  //   style: {'whiteSpace': 'normal'}
                  // },
                  {
                    dataField: "isEnabledText",
                    text: "Is Enabled",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "actions",
                    text: "Actions",
                    csvExport: false,
                  },
                ]}
                search
                exportCSV
              >
                {(props) => (
                  <div className="py-4 table-responsive">
                    <Grid container className="pl-4">
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        style={{ marginBottom: "15px" }}
                      >
                        {/* <Tooltip
                          title="Add new subscription package"
                          style={{ margin: "5px" }}
                        >
                          <Button
                            variant="contained"
                            size="small"
                            classes={{
                              root: classes.buttonContainedPrimary,
                            }}
                            onClick={() => {
                              clearCurrentRecord();
                              setAddModal(true);}}
                          >
                            <span>Add</span>
                          </Button>
                        </Tooltip> */}

                        {/* <Tooltip
                          title="This will copy to your download the table content."
                          style={{ margin: "5px" }}
                        > */}
                          <ExportCSVButton
                            className="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedSizeSmall MuiButton-sizeSmall"
                            {...props.csvProps}
                          >
                            <span className="MuiButton-label">Download</span>
                          </ExportCSVButton>
                        {/* </Tooltip> */}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <div
                          id="datatable-basic_filter"
                          className="dataTables_filter px-4 pb-1 float-right"
                        >
                          <label>
                            Search:
                            <SearchBar
                              className="form-control-sm"
                              placeholder=""
                              {...props.searchProps}
                            />
                          </label>
                        </div>
                      </Grid>
                    </Grid>

                    
                    <BootstrapTable
                      ref={componentRef}
                      {...props.baseProps}
                      bootstrap4={true}
                      pagination={pagination}
                      bordered={true}
                      striped={true}
                      //filter={ filterFactory() }
                      noDataIndication={() =>
                        isLoading ? (
                          <Box
                            component={Grid}
                            container
                            justifyContent="center"
                            className="justify-content-center"
                          >
                            <div
                              className="text-center"
                              style={{ width: "20%" }}
                            >
                              <LoadingAnimation />{" "}
                            </div>
                          </Box>
                        ) : (
                          <h4>No Records</h4>
                        )
                      }
                      id="main-table"
                    />
                    
                  </div>
                )}
              </ToolkitProvider>
              </div>
            </Card>
          </Grid>
        </Grid>
        <Dialog
                classes={{
                  root: classes.center + " " + classes.modalRoot,
                  paper: classes.modal + " " + classes.modalSmall,
                }}
                open={addModal && !isLoading}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setAddModal(false)}
              >
                <DialogTitle
                  disableTypography
                  className={classes.modalHeader}
                >
                  <h4 className={classes.modalTitle}>
                    {id == null || id === "" ? "Add" : "Edit"} Pro Subscription Package
                  </h4>
                </DialogTitle>
                <DialogContent
                  className={classes.modalBody + " " + classes.modalSmallBody}
                >
                  <form>


                <FormGroup>
                  <FormLabel>Name (English)</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Name (English)"
                    value={nameEn ?? ""}
                    onChange={(e) => setNameEn(e.target.value)}
                  />
                </FormGroup>

                <FormGroup>
                  <FormLabel>Name (Arabic)</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Name (Arabic)"
                    value={nameAr ?? ""}
                    onChange={(e) => setNameAr(e.target.value)}
                  />
                </FormGroup>
                  

                <FormGroup>
                  <FormLabel>Price (Monthly)</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="number"
                    placeholder="Price (Monthly)"
                    value={priceMonthly ?? ""}
                    onChange={(e) => setPriceMonthly(e.target.value)}
                  />
                </FormGroup>


                <FormGroup>
                  <FormLabel>Price (Annually)</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="number"
                    placeholder="Price (Annually)"
                    value={priceAnnually ?? ""}
                    onChange={(e) => setPriceAnnually(e.target.value)}
                  />
                </FormGroup>

                <FormGroup>
                  <FormLabel>Header Color</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="#ffffff"
                    value={headerColor ?? ""}
                    onChange={(e) => setHeaderColor(e.target.value)}
                  />
                </FormGroup>


                <FormGroup>
                  <FormLabel>Discount Percentage</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="number"
                    placeholder="# %"
                    value={discountPercentage ?? ""}
                    onChange={(e) => setDiscountPercentage(e.target.value)}
                  />
                </FormGroup>


                <FormGroup>
                  <FormLabel>Minimum Order Amount</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="number"
                    placeholder="Minimum Amount"
                    value={minimumOrder ?? ""}
                    onChange={(e) => setMinimumOrder(e.target.value)}
                  />
                </FormGroup>


                <FormGroup>
                  <FormLabel>Maximum Order Amount</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="number"
                    placeholder="Maximum Amount"
                    value={maximumOrder ?? ""}
                    onChange={(e) => setMaximumOrder(e.target.value)}
                  />
                </FormGroup>

                {/* <FormGroup>
                  <FormLabel>Country</FormLabel>
                  <FormControl variant="outlined" fullWidth>
                    <Select value={countryId} onChange={(e) => setCountryId(e.target.value)} IconComponent={KeyboardArrowDown}>
                    {countries.map(function(country, i){
                        return <MenuItem value={country.id}>{country.nameEn}</MenuItem>;
                    })}
                    </Select>
                  </FormControl>
                </FormGroup> */}

                <FormGroup>
                  <FormLabel>Is Enabled</FormLabel>
                  <FormControl variant="outlined" fullWidth>
                    <Select value={isEnabled} onChange={(e) => setIsEnabled(e.target.value)} IconComponent={KeyboardArrowDown}>
                      <MenuItem value={1}>Yes</MenuItem>
                      <MenuItem value={0}>No</MenuItem>
                    </Select>
                  </FormControl>
                </FormGroup>

                <FormGroup>
                  <FormLabel>Image</FormLabel>
                  <FormControl variant="outlined" fullWidth>
                      <div className="fileinput">
                      <div className={"thumbnail"}>
                          <img src={logoUrl} width="100px" />
                        </div>
                        <input
                          type="file"
                          id="imageFile"
                          onChange={handleImageChange}
                          ref={fileInput}
                        />
                      </div>
                  </FormControl>
                </FormGroup>
                  </form>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => setAddModal(false)}
                  >
                    Cancel
                  </Button>
                    <Button
                      onClick={() => updateSubscriptionPackageAction()
                        /*id == null || id === "" ? addSubscriptionPackageAction() : updateSubscriptionPackageAction()*/
                      }
                      
                  classes={{
                    root: classes.buttonContainedPurple100,
                  }}
                      variant="contained"
                    >
                      {id == null || id === "" ? "Add" : "Update"}
                    </Button>
                  
                </DialogActions>
              </Dialog>
        <Snackbar
          place="tr"
          color="success"
          // icon={AddAlert}
          message={notifMessage}
          open={success}
          closeNotification={() => setSuccess(false)}
          close
        />

        <Snackbar
          place="tr"
          color="rose"
          // icon={AddAlert}
          message={notifMessage}
          open={showError}
          closeNotification={() => setShowError(false)}
          close
        />
      </Container>
    </>
  );
};

export default ProSubscriptionPackagesTable;
